var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLessee = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 21.43,16.87 C 22.05,16.42 22.18,15.55 21.73,14.93 C 21.27,14.31 20.41,14.18 19.79,14.64 L 15.63,17.7 L 11.44,17.7 C 11.14,17.7 10.89,17.45 10.89,17.14 C 10.89,16.84 11.14,16.59 11.44,16.59 L 12,16.59 L 14.22,16.59 C 14.84,16.59 15.33,16.09 15.33,15.48 C 15.33,14.86 14.84,14.37 14.22,14.37 L 12,14.37 L 11.44,14.37 L 8.73,14.37 C 7.72,14.37 6.74,14.71 5.95,15.34 L 4.39,16.59 L 3.11,16.59 C 2.5,16.59 2,17.09 2,17.7 L 2,19.92 C 2,20.54 2.5,21.03 3.11,21.03 L 8.67,21.03 L 14.24,21.03 C 15.25,21.03 16.23,20.71 17.04,20.11 L 21.44,16.87 L 21.43,16.87 M 8.72,16.59 A 0.02,0.02 0 1,1 8.69,16.59 A 0.02,0.02 0 1,1 8.72,16.59",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 12,2.97 C 12.53,2.97 12.89,3.49 12.89,4.17 L 12.89,6.38 L 16.2,8.27 L 16.2,9.32 L 12.89,8.37 L 12.89,10.26 L 13.94,11.1 L 13.94,12 L 12,11.47 L 10.06,12 L 10.06,11.1 L 11.11,10.26 L 11.11,8.37 L 7.8,9.32 L 7.8,8.27 L 11.11,6.38 L 11.11,4.17 C 11.11,3.49 11.48,2.97 12,2.97 L 12,2.97",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLessee, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lessee.31083a4b.svg";
export { ForwardRef as ReactComponent };